import script from "./ProjectsComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./ProjectsComponent.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__